import React, { Fragment, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createStructuredSelector } from 'reselect';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import {
  loadStatementSettings as loadStatementSettingsRequest,
  fetchPaymentMethods as fetchPaymentMethodsRequest,
  getBillingAccount as getBillingAccountRequest,
} from 'containers/PrimoProfile/actions';
import { selectSelectedServiceLocationId } from 'containers/PrimoAccount/selectors';
import { showDrawer } from 'containers/DrawerManager/actions';
import EditInvoiceDrawer from 'containers/PrimoProfile/BillingInformation/InvoiceForm/InvoiceDrawer';
import { selectBillingAccount } from 'containers/PrimoProfile/selectors';
import commonStyles from 'containers/PrimoProfile/styles.scss';
import { GTM_TRACKING_TAGS } from 'utils/constants';
import { H1 } from 'components/Ui';
import BillingDetailedInfo from './BillingDetailedInfo';
import BillingInformationEdit from './BillingInformationEdit';
import EditBillingContactDrawer from './EditBillingContactDrawer';
import EditBillingAddressDrawer from './EditBillingAddressDrawer';
import GenericBlock from '../GenericBlock';
import styles from './styles.scss';

import {
  EDIT_BILLING_INFORMATION,
  EDIT_INVOICE_INFORMATION,
} from './constants';

function BillingInformation({
  serviceLocationId,
  loadStatementSettings,
  fetchPaymentMethods,
  getBillingAccount,
}) {
  const dispatch = useDispatch();
  const billingAccount = useSelector(selectBillingAccount());

  useEffect(() => {
    if (serviceLocationId) {
      fetchPaymentMethods();
      loadStatementSettings();
      getBillingAccount();
    }
  }, [serviceLocationId]);

  const handleShowForm = () => {
    dispatch(showDrawer(EDIT_BILLING_INFORMATION));
  };

  const handleShowInvoice = () => {
    dispatch(showDrawer(EDIT_INVOICE_INFORMATION));
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <GenericBlock title="Billing and payments">
      <Fragment>
        <div
          className={commonStyles.container}
          data-tracking={GTM_TRACKING_TAGS['Billing and payments']}
        >
          <div className={commonStyles.blockContainer}>
            {!isMobile && (
              <div className={commonStyles.blockHeaderContainer}>
                <H1 className={commonStyles.blockHeaderText}>
                  Billing and payments
                </H1>
              </div>
            )}
            <div
              className={classnames(
                commonStyles.blockContent,
                styles.blockOverride,
              )}
            >
              <BillingDetailedInfo
                showPaymentMethods={handleShowForm}
                showInvoiceSettings={handleShowInvoice}
                billingContact={billingAccount}
              />
            </div>
          </div>
        </div>
        <EditInvoiceDrawer />
        <BillingInformationEdit />
        <EditBillingContactDrawer billingAccount={billingAccount} />
        <EditBillingAddressDrawer billingAccount={billingAccount} />
      </Fragment>
    </GenericBlock>
  );
}

BillingInformation.propTypes = {
  serviceLocationId: PropTypes.string,
  loadStatementSettings: PropTypes.func,
  fetchPaymentMethods: PropTypes.func,
  getBillingAccount: PropTypes.func,
};
const mapStateToProps = createStructuredSelector({
  serviceLocationId: selectSelectedServiceLocationId(),
});
const mapDispatchToProps = {
  fetchPaymentMethods: fetchPaymentMethodsRequest,
  loadStatementSettings: loadStatementSettingsRequest,
  getBillingAccount: getBillingAccountRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingInformation);
